import { SaveStationModel } from 'src/app/shared/models/station.model';

export class ChecklistValues {
  Comment: string;
  CreatedOn?: Date;
  Id: number;
  IsActive?: boolean;
  Name: string;
  Stations: SaveStationModel[] = [];

  constructor(checklist: any) {
    this.Comment = checklist.Comment;
    this.CreatedOn = checklist.CreatedOn;
    this.Id = checklist.Id;
    this.IsActive = checklist.IsActive;
    this.Name = checklist.Name;
    this.Stations = checklist.Stations;
  }
}
